import { useEffect, useRef } from 'react';

interface Props {
  isPaused?: boolean;
  bgVideo?: string;
}

export default function VideoBackground({ isPaused, bgVideo }: Props) {
  // ref
  const ref = useRef<HTMLVideoElement>(null);

  // effect
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const play = ref.current.play.bind(ref.current);
    const pause = ref.current.pause.bind(ref.current);

    (isPaused ? pause : play)();
  }, [isPaused]);

  return (
    <video autoPlay muted loop playsInline ref={ref}>
      {typeof window !== 'undefined' && (
        <>
          <source src={`${bgVideo}.webm`} type="video/webm" />
          <source src={`${bgVideo}.mp4`} type="video/mp4" />
        </>
      )}
    </video>
  );
}
